import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { includes } from "lodash";

import Header from "./Header";
import Subheader from "./Subheader";
import Loader from "components/Loader";
import StateStore from "globalStates/Store";
import AppStore from "context";
import useContextService from "hooks/useContextService";
import Dashboard from "pages/Dashboard";
import SideBar from "./SideBar";
// import CardList from "components/CardList";
// import CustomCarousel from "components/Upcoming";
// import SearchInput from "components/SearchInput";
import OrderEntry from "pages/OrderEntry";
import SiderBar from "./SideBar";

const Next = () => {
  const location = useLocation();
  const { states, resetStates } = useContextService();
  const { loading } = states;

  useEffect(() => {
    const { pathname } = new URL(window.location.href);
    const hasPathChanged = !includes(pathname, "/purchaseorder");
    if (hasPathChanged) {
      resetStates("purchaseorder");
    }
  }, [location]);

  return (
    <>
      {loading && <Loader opacity={0.01} color="black" />}
      <Outlet />
    </>
  );
};

const Layout = (props) => {
  const { modules } = props;
  return (
    <AppStore>
      <StateStore>
        <section>
          <Header />
          {/* <Subheader modules={modules} /> */}
          <div className="d-flex mt-10 bg-white">
            <div className="new-sider">
              <SideBar />
            </div>
            <div className="content-wrapper " >
              <Next />
            </div>
          </div>
        </section>
      </StateStore>
    </AppStore>
  );
};

export default Layout;
